import { render, staticRenderFns } from "./ListFeedbackItems.vue?vue&type=template&id=4da6de86"
import script from "./ListFeedbackItems.vue?vue&type=script&lang=js"
export * from "./ListFeedbackItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4da6de86')) {
      api.createRecord('4da6de86', component.options)
    } else {
      api.reload('4da6de86', component.options)
    }
    module.hot.accept("./ListFeedbackItems.vue?vue&type=template&id=4da6de86", function () {
      api.rerender('4da6de86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ListFeedbackItems.vue"
export default component.exports